import { useQuery, type QueryClient } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getCustomerOrdersV3,
  type CustomerOrdersV3Params,
} from '@hungryroot/rest/api/v3/customers/self/orders/get';

/**
 * Exported for testing. Do NOT use directly. Instead use `invalidateOrdersV3`
 */
export const GET_CUSTOMER_ORDERS_V3_QUERY_KEY = ['Customer Orders', 'v3'];

const timeLimit = 5 * 60 * 1000;

export async function invalidateOrdersV3(
  queryClient: QueryClient,
  params: CustomerOrdersV3Params = {}
) {
  await queryClient.invalidateQueries({
    queryKey: [...GET_CUSTOMER_ORDERS_V3_QUERY_KEY, params],
  });
}

export function useGetOrdersV3(
  params: CustomerOrdersV3Params = {},
  options?: {
    enabled?: boolean;
  }
) {
  return useQuery({
    queryKey: [...GET_CUSTOMER_ORDERS_V3_QUERY_KEY, params],
    queryFn: async () => {
      const resp = await getCustomerOrdersV3(params);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    enabled: options?.enabled !== false,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}
